import { getDateString } from '../../../utils/timeUtils';
import { getUserFullName } from '../../../utils/userUtils';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
// @ts-expect-error Untyped import
import { getUpdatedAt } from 'reporting-action-components/data/schemas/reportSchema';
// @ts-expect-error Untyped import
import { getUpdatedByUser } from 'reporting-action-components/data/schemas/reportSchema';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReportLastUpdated = ({
  report
}) => {
  const lastUpdatedTimestamp = getUpdatedAt(report);
  const lastUpdatedUser = getUpdatedByUser(report);
  if (!lastUpdatedTimestamp) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reports.reportCard.details.lastUpdated",
      options: {
        updatedDate: '--'
      }
    });
  }
  const lastUpdatedUserName = getUserFullName(lastUpdatedUser);
  if (!lastUpdatedUserName) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reports.reportCard.details.lastUpdated",
      options: {
        updatedDate: getDateString(lastUpdatedTimestamp)
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "reports.reportCard.details.lastUpdatedBy",
    options: {
      updatedDate: getDateString(lastUpdatedTimestamp),
      userFullName: lastUpdatedUserName
    }
  });
};